module.exports = __webpack_public_path__ + "static/media/parent-child.cd43dc98.png";